import styled, { css } from 'styled-components';
import { Breakpoints } from '../../../../styled/constants';
import { Typography } from '../../../ui/Typography';
import { FlexCenterAligned, FlexibleDiv } from '../../../../styled/common';
import { tagStyles } from '../../../ui/Typography/styles';

export const locationSectionStyles = css`
  @media (min-width: ${Breakpoints.smallDesktop}px) {
    padding: 30px 40px;
  }
`;

export const LocationAddress = styled(Typography)`
  display: block;
  margin-bottom: 10px;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    ${tagStyles.title_3_desc};
    line-height: 20px;
    margin-bottom: 20px;
  }
`;

export const LocationMap = styled.div`
  background-image: url('/static/images/residences/map.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;
  width: 100%;
  height: 140px;
  border-radius: 7px;
  overflow: hidden;
  cursor: pointer;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    display: none;
  }
`;

export const LocationsContainer = styled(FlexibleDiv)`
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 15px;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    margin: 0 0 20px 0;
  }
`;

export const LocationItem = styled(FlexCenterAligned)`
  height: 36px;
  padding: 0 15px;
  background-color: ${({ theme }) => theme.colors.background.tertiary};
  border-radius: 50px;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    height: 38px;
  }
`;

export const LocationText = styled(Typography)`
  @media (min-width: ${Breakpoints.smallDesktop}px) {
    ${tagStyles.body_1};
  }
`;

export const DesktopLocationMap = styled.div`
  @media (min-width: ${Breakpoints.smallDesktop}px) {
    height: 460px;
    border-radius: 7px;
    overflow: hidden;
  }
`;
